import { type FC, useState } from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import { ConfirmDialog } from "@/admin/shared/ui";
import { useSetContractPaymentStatusMutation } from "@/admin/entities/contractPayments";

interface MarkContractPaymentPaidDialogProps {
  open: boolean;
  paymentId: string;
  onClose: () => void;
  onCompleted?: () => void;
}

function today(): string {
  return new Date().toISOString().slice(0, 10);
}

/**
 * «Оплачен» с датой: дата поступления почти никогда не совпадает с днём,
 * когда админ доходит до кабинета, поэтому она вводится руками.
 */
export const MarkContractPaymentPaidDialog: FC<
  MarkContractPaymentPaidDialogProps
> = ({ open, paymentId, onClose, onCompleted }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [paidAt, setPaidAt] = useState(today());
  const [note, setNote] = useState("");

  const [setStatus, { loading, error }] = useSetContractPaymentStatusMutation({
    onCompleted: () => {
      enqueueSnackbar("Платёж отмечен оплаченным", { variant: "success" });
      onClose();
      onCompleted?.();
    },
    onError: () => {
      // Ошибку показывает ErrorMessage внутри ConfirmDialog.
    },
  });

  const handleConfirm = () => {
    void setStatus({
      variables: {
        id: paymentId,
        status: "paid",
        paidAt: new Date(`${paidAt}T00:00:00.000Z`).toISOString(),
        note: note || undefined,
      },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onCancel={onClose}
      onConfirm={handleConfirm}
      confirmTitle="Платёж оплачен"
      confirmText="Укажите дату поступления денег."
      loading={loading}
      error={error}
      disabled={!paidAt}
    >
      <Stack spacing={2}>
        <TextField
          label="Дата оплаты"
          type="date"
          value={paidAt}
          onChange={(event) => setPaidAt(event.target.value)}
          fullWidth
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <TextField
          label="Заметка"
          value={note}
          onChange={(event) => setNote(event.target.value)}
          fullWidth
          multiline
          minRows={2}
        />
      </Stack>
    </ConfirmDialog>
  );
};
